import React, { useCallback, useEffect, useState } from "react";
import { serviceGetQuizDetails } from "../../../services/Quiz.service";
import { useParams } from "react-router";
import history from "../../../libs/history.utils";
import RouteName from "../../../routes/Route.name";

function useQuizDetail() {
  const [data, setData] = useState({});
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      serviceGetQuizDetails({ id }).then((res) => {
        if (!res?.error) {
          const response = res?.data?.details;
          setData(response);
        }
      });
    }
  }, [id]);

  const handleEdit = useCallback(() => {
    history.push(RouteName.QUIZ_UPDATE + id);
  }, [id]);

  const handleCopy = useCallback(() => {
    history.push(`${RouteName.QUIZ_UPDATE}${id}`,{"is_duplicate":true});
  }, []);

  return {
    data,
    handleEdit,
    handleCopy
  };
}

export default useQuizDetail;
